module.exports = __webpack_public_path__ + "img/balance.1bb7eca5.jpg";